"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M40 24.5V40H8V8h15.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H5a1 1 0 0 0-1 1v38a1 1 0 0 0 1 1h38a1 1 0 0 0 1-1V24.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5z" }),
  React.createElement("path", { d: "M30.241 4a1.008 1.008 0 0 0-.655 1.716l4.228 4.228-9.842 9.842a.5.5 0 0 0 0 .707l3.536 3.535a.5.5 0 0 0 .707 0l9.842-9.842 4.217 4.214a1 1 0 0 0 1.706-.655V4z" })
);

